import * as Sentry from "@sentry/react";

export const get = async (url) => {
  const xAuthToken = localStorage.getItem("X-Auth-Token");
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "X-Auth-Token": xAuthToken,
      },
    });
    return response;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error("An error occurred while making the GET request.");
  }
};
export const newGet = async (url) => {
  const xAuthToken = localStorage.getItem("X-Auth-Token");
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "X-Auth-Token": xAuthToken,
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error("An error occurred while making the GET request.");
  }
};
export const post = async (url, data) => {
  try {
    const xAuthToken = localStorage.getItem("X-Auth-Token");

    const headers = {
      "Content-Type": "application/json",
    };

    if (xAuthToken) {
      headers["X-Auth-Token"] = xAuthToken;
    }

    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    return response;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error("An error occurred while making the POST request.");
  }
};

export const postFormData = async (url, formData) => {
  try {
    const xAuthToken = localStorage.getItem("X-Auth-Token");

    const headers = {};

    if (xAuthToken) {
      headers["X-Auth-Token"] = xAuthToken;
    }

    const response = await fetch(url, {
      method: "POST",
      headers,
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    Sentry.captureException(error);
    throw new Error("An error occurred while making the POST request.");
  }
};

export const put = async (url, data) => {
  try {
    const xAuthToken = localStorage.getItem("X-Auth-Token");

    const headers = {
      "Content-Type": "application/json",
    };

    if (xAuthToken) {
      headers["X-Auth-Token"] = xAuthToken;
    }

    const response = await fetch(url, {
      method: "PUT",
      headers,
      body: JSON.stringify(data),
    });
    return response;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error("An error occurred while making the PUT request.");
  }
};

export const del = async (url) => {
  const xAuthToken = localStorage.getItem("X-Auth-Token");
  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "X-Auth-Token": xAuthToken,
      },
    });
    return response;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error("An error occurred while making the DELETE request.");
  }
};
